import { Color } from './types';

export const ColorVariants: Record<Color, { bar: string; card: string }> = {
    blue: {
        bar: 'bg-blue-500',
        card: 'from-blue-100 to-blue-100/50',
    },
    green: {
        bar: 'bg-green-500',
        card: 'from-green-100 to-green-100/50',
    },
    orange: {
        bar: 'bg-orange-500',
        card: 'from-orange-100 to-orange-100/50',
    },
    red: {
        bar: 'bg-red-500',
        card: 'from-red-100 to-red-100/50',
    },
    turquoise: {
        bar: 'bg-turquoise-500',
        card: 'from-turquoise-100 to-turquoise-100/50',
    },
    purple: {
        bar: 'bg-purple-500',
        card: 'from-purple-100 to-purple-100/50',
    },
    rose: {
        bar: 'bg-rose-500',
        card: 'from-rose-100 to-rose-100/50',
    },
};

/**
 * Barva kategorie chybí častěji, než se zdá — sloupec `color` je v DB nullable,
 * lekce nemusí patřit do žádné kategorie a formulář podkategorií barvu vůbec
 * nenastavuje. Přímý `ColorVariants[color]` v takovém případě vrátí `undefined`
 * a přístup k `.card` shodí render celé aplikace, nejen dotčené karty.
 */
export function colorVariant(color: Color | null | undefined) {
    return (color && ColorVariants[color]) || ColorVariants.blue;
}
